import React from 'react';
import { Button, Card, Divider, Space, Tag } from 'antd';
import { ArrowLeftOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const DetailView = ({
  title,
  onBack,
  onEdit,
  onDelete,
  children,
  actions = [],
  tags = [],
  subtitle = null,
  loading = false,
  className = '',
  ...props
}) => {
  return (
    <div className={`detail-view ${className}`} {...props}>
      {/* Header */}
      <div className="mb-6">
        {/* Back above title */}
        <div className="mb-2">
          {onBack && (
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={onBack}
              className="text-gray-600 hover:text-gray-800 dark:text-slate-300 dark:hover:text-slate-100 px-0"
            >
              Back
            </Button>
          )}
        </div>

        {/* Title row with actions/tags */}
        <div className="flex items-start justify-between mb-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100 mb-1">{title}</h1>
            {subtitle && (
              <p className="text-gray-600 dark:text-slate-300">{subtitle}</p>
            )}
          </div>
          <Space>
            {tags.map((tag, index) => (
              <Tag key={`tag-${index}`} color={tag.color || 'default'}>
                {tag.label}
              </Tag>
            ))}
            
            {actions.map((action, index) => (
              <Button
                key={`action-${index}`}
                type={action.type || 'default'}
                icon={action.icon}
                onClick={action.onClick}
                loading={action.loading}
                danger={action.danger}
              >
                {action.label}
              </Button>
            ))}
            
            {onEdit && (
              <Button
                type="default"
                icon={<EditOutlined />}
                onClick={onEdit}
              >
                Edit
              </Button>
            )}
            
            {onDelete && (
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={onDelete}
              >
                Delete
              </Button>
            )}
          </Space>
        </div>
        
        <Divider className="my-4" />
      </div>

      {/* Content */}
      <div className="detail-content">
        {children}
      </div>
    </div>
  );
};

// Helper component for detail sections
export const DetailSection = ({ 
  title, 
  children, 
  className = '',
  extra = null,
  ...props 
}) => (
  <Card 
    title={title}
    extra={extra}
    className={`mb-6 ${className}`}
    {...props}
  >
    {children}
  </Card>
);

// Helper component for detail fields
export const DetailField = ({ 
  label, 
  value, 
  render,
  className = '',
  ...props 
}) => (
  <div className={`detail-field mb-4 ${className}`} {...props}>
    <div className="text-sm font-medium text-gray-500 dark:text-slate-400 mb-1">{label}</div>
    <div className="text-base text-gray-900 dark:text-slate-100">
      {render ? render(value) : (value || '-')}
    </div>
  </div>
);

export default DetailView;
